<section class="dev-docs-shell">
  <header class="dev-docs-header">
    <h1>Documentation Dev: Deploiement & DBeaver</h1>
    <p>Cette page est exposee uniquement en environnement de developpement.</p>
    <span class="env-pill" [class.env-pill-prod]="production">
      Environment production: {{ production }}
    </span>
  </header>

  <article class="dev-docs-card">
    <h2>1. Deployer correctement</h2>

    <h3>Frontend uniquement</h3>
    <pre><code [innerText]="deployFrontCmd"></code></pre>

    <h3>Backend uniquement</h3>
    <pre><code [innerText]="deployBackCmd"></code></pre>

    <h3>Frontend + Backend</h3>
    <pre><code [innerText]="deployAllCmd"></code></pre>

    <h3>Regles importantes</h3>
    <ul>
      <li>Toujours builder le frontend en <strong>production</strong> pour utiliser <code>environment.prod.ts</code>.</li>
      <li>Ne jamais exposer PostgreSQL publiquement sur Internet.</li>
      <li>Verifier apres deploy: <code>docker compose --env-file .env ps</code> et <code>logs -f --tail=200</code>.</li>
      <li>En cas de PWA cache, forcer un hard refresh navigateur (<code>Ctrl+Shift+R</code>).</li>
    </ul>
  </article>

  <article class="dev-docs-card">
    <h2>2. Regles de connexion DBeaver (DB prod)</h2>

    <h3>Etape A - Tunnel SSH local</h3>
    <pre><code [innerText]="dbeaverTunnelCmd"></code></pre>

    <h3>Etape B - Parametres DBeaver</h3>
    <ul>
      <li>Host: <code>127.0.0.1</code></li>
      <li>Port: <code>55432</code></li>
      <li>Database: <code>spay</code> (ou <code>POSTGRES_DB</code>)</li>
      <li>User: <code>spay</code> (ou <code>POSTGRES_USER</code>)</li>
      <li>Password: valeur <code>POSTGRES_PASSWORD</code> du serveur</li>
      <li>SSL: <code>disable</code> (car tunnel SSH deja chiffre)</li>
    </ul>

    <h3>Regles de securite</h3>
    <ul>
      <li>Utiliser idealement un compte DB read-only pour DBeaver.</li>
      <li>Rotater immediatement tout secret compromis.</li>
      <li>Ne jamais committer des mots de passe reels dans Git.</li>
    </ul>
  </article>
</section>
